addEventListener('DOMContentLoaded', () => {
  const contactForm = document.querySelector('.contact-module__form');

  if (contactForm)
    new ResizeObserver(([e]) => {
      contactForm.style.minHeight = `${Math.max(
        e.target.offsetHeight,
        parseFloat(contactForm.style.minHeight) || 0,
      )}px`;
    }).observe(contactForm.querySelector('.form-component'));
});
